import { useParams } from 'react-router-dom';

import { AppSettingsPage } from '~/components/pages/AppSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
